module.exports = __webpack_public_path__ + "img/SharedCharter_AppBanner-mobil.e1c9cbf8.jpg";